<template>
  <v-container fluid>
    <form>
      <v-text-field v-model="contato.telefone" required counter maxlength="20">
        <template #label>
          Telefone
          <span class="red--text"><strong> *</strong></span>
        </template></v-text-field
      >
      <v-text-field v-model="contato.email" required counter maxlength="100">
        <template #label>
          E-mail
          <span class="red--text"><strong> *</strong></span>
        </template>
      </v-text-field>
      <v-text-field v-model="contato.contato_urgencia" required counter maxlength="200">
        <template #label>
          Contato de Urgência
          <span class="red--text"><strong> *</strong></span>
        </template>
      </v-text-field>
     <v-toolbar elevation="0">
        <v-btn color="orange lighten-3" @click="voltar"> Voltar </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mr-4" @click="salvar"> Salvar </v-btn>
      </v-toolbar>
    </form>
  </v-container>
</template>

<script>
import Contato from "@/models/contato";
import * as ContatoService from "@/services/contato.service";

export default {
  data() {
    return {
      contato: new Contato(),
    };
  },
  mounted() {
    this.loadContato();
  },
  methods: {
     voltar() {
      this.$emit('voltar')
    },
    salvar() {
      this.$nprogress.start();
      ContatoService.create(this.contato)
        .then(() => {
          this.$msg.success("Contato salvo com sucesso!");
          this.$emit("salvou");
        })
        .finally(() => this.$nprogress.done());
    },
    loadContato() {
      this.$nprogress.start();
      ContatoService.getOne()
        .then(
          (res) =>
            (this.contato = new Contato(
              res.data.id,
              res.data.telefone,
              res.data.email,
              res.data.contato_urgencia
            ))
        )
        .finally(() => this.$nprogress.done());
    },
  },
};
</script>